import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Popover } from "antd";
import { usePermisos } from "../../context/PermisosContext";
import { performLogout } from "../../utils/logout";
import { MODULOS } from "../../constants/modulos";
import { getEmpresaConfig } from "../utils/empresaConfig";
import logoIcon from "../../assets/img/logo-icon.png";

const SIDEBAR_COLLAPSED = 56;
const SIDEBAR_EXPANDED = 228;

export default function VerticalSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname || "/";
  const [hovered, setHovered] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const { perm } = usePermisos() || { perm: () => false };

  const [empresa, setEmpresa] = useState({ nombre: "", logoDataUrl: null });
  useEffect(() => {
    let alive = true;
    getEmpresaConfig().then((c) => { if (alive) setEmpresa(c || {}); });
    return () => { alive = false; };
  }, []);
  const sidebarLogo = empresa.logoDataUrl;
  const sidebarTitle = empresa.nombre || "";

  const [userUsuario, setUserUsuario] = useState(() => localStorage.getItem("usuario") || "—");
  const [userAvatar, setUserAvatar] = useState(() => localStorage.getItem("userAvatar") || "");

  useEffect(() => {
    const sync = () => setUserUsuario(localStorage.getItem("usuario") || "—");
    window.addEventListener("permisos-refresh", sync);
    return () => window.removeEventListener("permisos-refresh", sync);
  }, []);

  useEffect(() => {
    const syncAvatar = (e) => setUserAvatar(e.detail || localStorage.getItem("userAvatar") || "");
    window.addEventListener("avatar-updated", syncAvatar);
    return () => window.removeEventListener("avatar-updated", syncAvatar);
  }, []);

  const userInitials = (() => {
    const name = userUsuario.trim();
    const a = name[0] || "G";
    const b = name[1] || "J";
    return (a + b).toUpperCase();
  })();

  const width = hovered ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED;

  const ALL_ITEMS = [
    {
      label: "Inicio",
      icon: <i className="fa-solid fa-house"></i>,
      path: "/app/home",
      match: (p) => p.startsWith("/app/home"),
      show: true,
    },
    ...MODULOS.map((m) => ({
      label: m.label,
      icon: m.icon,
      path: m.path,
      match: (p) => p.startsWith(m.path),
      show: perm(m.key, "modulo"),
    })),
  ];

  const visibleItems = ALL_ITEMS.filter((i) => i.show);

  const userCard = (
    <div className="eh-user-pop">
      <div className="eh-user-avatar">
        {userAvatar ? <img src={userAvatar} alt="avatar" /> : userInitials}
      </div>
      <div className="eh-user-email">{userUsuario}</div>
      <div className="eh-user-actions">
        <button
          type="button"
          className="eh-user-btn"
          onClick={() => { setUserOpen(false); navigate("/app/perfil"); }}
        >
          Perfil
        </button>
        <button
          type="button"
          className="eh-user-btn danger"
          onClick={() => {
            setUserOpen(false);
            performLogout();
          }}
        >
          Cerrar sesion
        </button>
      </div>
    </div>
  );

  return (
    <aside
      className="vs-root"
      style={{ width }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="vs-logo">
        {sidebarLogo ? (
          <img src={sidebarLogo} alt="Logo" className="vs-logo-img" />
        ) : (
          <img src={logoIcon} alt="Gigante Jr." className="vs-logo-img" />
        )}
        {hovered && <span className="vs-logo-text">{sidebarTitle}</span>}
      </div>

      <nav className="vs-nav vs-nav--all">
        {visibleItems.map((item) => {
          const active = item.match(pathname);
          return (
            <button
              key={item.path}
              type="button"
              className={`vs-item${active ? " vs-item--active" : ""}`}
              onClick={() => navigate(item.path)}
              title={!hovered ? item.label : undefined}
            >
              <span className="vs-item-icon">{item.icon}</span>
              {hovered && <span className="vs-item-label">{item.label}</span>}
            </button>
          );
        })}
      </nav>

      <div className="vs-bottom">
        <Popover
          content={userCard}
          trigger="click"
          placement="rightBottom"
          open={userOpen}
          onOpenChange={setUserOpen}
          overlayClassName="eh-popover vs-user-popover"
        >
          <button type="button" className="vs-avatar-btn" title={!hovered ? userUsuario : undefined}>
            <span className="vs-avatar">
              {userAvatar ? (
                <img src={userAvatar} alt="avatar" style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }} />
              ) : (
                userInitials
              )}
            </span>
            {hovered && <span className="vs-avatar-email">{userUsuario}</span>}
          </button>
        </Popover>
      </div>
    </aside>
  );
}
